import React from 'react';
import {NodeProps} from 'reactflow';

import {EndNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import BenchlingNode from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';

export default function StopNodeRenderer(props: NodeProps<EndNodeData>): JSX.Element {
  return <BenchlingNode<never, EndNodeData> {...props} />;
}
